// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Document Management Module - Styles
 */

.document-management-container {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding-top: 0;
  margin-top: 0;
  position: relative;
  z-index: 1;
}

.document-management-container h2 {
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.document-management-container .d-flex {
  display: flex !important;
  visibility: visible !important;
}

/* Ensure upload button is always visible */
.document-management-container .btn-primary {
  position: relative;
  z-index: 10;
  display: inline-flex !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.document-card {
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #dee2e6;
}

.document-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.document-card .card-body {
  display: flex;
  flex-direction: column;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}

.status-indicator.published {
  background-color: #28a745;
}

.status-indicator.approved {
  background-color: #28a745;
}

.status-indicator.under-review {
  background-color: #ffc107;
}

.status-indicator.draft {
  background-color: #17a2b8;
}

.status-indicator.expired {
  background-color: #dc3545;
}

.compliance-status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 600;
}

.compliance-status-badge.compliant {
  background-color: #d4edda;
  color: #155724;
}

.compliance-status-badge.partially-compliant {
  background-color: #fff3cd;
  color: #856404;
}

.compliance-status-badge.non-compliant {
  background-color: #f8d7da;
  color: #721c24;
}

.gap-severity-badge {
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 600;
}

.gap-severity-badge.critical {
  background-color: #dc3545;
  color: white;
}

.gap-severity-badge.high {
  background-color: #fd7e14;
  color: white;
}

.gap-severity-badge.medium {
  background-color: #ffc107;
  color: #000;
}

.gap-severity-badge.low {
  background-color: #6c757d;
  color: white;
}

.version-history-item {
  border-left: 3px solid #dee2e6;
  padding-left: 16px;
  margin-bottom: 16px;
}

.version-history-item.current {
  border-left-color: #007bff;
}

.approval-timeline {
  position: relative;
  padding-left: 24px;
}

.approval-timeline::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #dee2e6;
}

.approval-timeline-item {
  position: relative;
  margin-bottom: 24px;
}

.approval-timeline-item::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #fff;
  border: 2px solid #dee2e6;
}

.approval-timeline-item.completed::before {
  background-color: #28a745;
  border-color: #28a745;
}

.approval-timeline-item.pending::before {
  background-color: #ffc107;
  border-color: #ffc107;
}

.dashboard-stat-card {
  border-left: 4px solid;
  transition: transform 0.2s;
}

.dashboard-stat-card:hover {
  transform: translateY(-2px);
}

.dashboard-stat-card.compliant {
  border-left-color: #28a745;
}

.dashboard-stat-card.partially-compliant {
  border-left-color: #ffc107;
}

.dashboard-stat-card.non-compliant {
  border-left-color: #dc3545;
}

.notification-item {
  border-left: 4px solid;
  transition: background-color 0.2s;
}

.notification-item:hover {
  background-color: #f8f9fa;
}

.notification-item.info {
  border-left-color: #17a2b8;
}

.notification-item.warning {
  border-left-color: #ffc107;
}

.notification-item.critical {
  border-left-color: #dc3545;
}

.file-upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  transition: border-color 0.2s, background-color 0.2s;
  cursor: pointer;
}

.file-upload-area:hover {
  border-color: #007bff;
  background-color: #f0f7ff;
}

.file-upload-area.dragover {
  border-color: #007bff;
  background-color: #e7f3ff;
}

.risk-level-badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.risk-level-badge.low {
  background-color: #d1ecf1;
  color: #0c5460;
}

.risk-level-badge.medium {
  background-color: #fff3cd;
  color: #856404;
}

.risk-level-badge.high {
  background-color: #f8d7da;
  color: #721c24;
}

.risk-level-badge.critical {
  background-color: #dc3545;
  color: white;
}

/* File Structure Styles */
.file-structure-tree {
  height: 100%;
  overflow-y: auto;
  background-color: transparent;
  padding: 0;
  width: 100%;
}

.file-structure-item {
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s;
  position: relative;
}

.file-structure-item:last-child {
  border-bottom: none;
}

.folder-item {
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
  -webkit-user-select: none;
          user-select: none;
  border-left: 3px solid transparent;
  position: relative;
}

.folder-item:hover {
  background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 100%);
  border-left-color: #ffc107;
}

.folder-item.custom-folder {
  background-color: #f0f7ff;
  border-left-color: #0dcaf0;
}

.folder-item.custom-folder:hover {
  background: linear-gradient(90deg, #cfe2ff 0%, #d1e7ff 100%);
  border-left-color: #0dcaf0;
}

.file-item {
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-left: 3px solid transparent;
  position: relative;
}

.file-item:hover {
  background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 100%);
  border-left-color: #007bff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.file-item:active {
  background-color: #e9ecef;
}

/* Folder icons with better styling */
.folder-item .fa-folder,
.folder-item .fa-folder-open {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

/* File icons */
.file-item .fa-file-pdf,
.file-item .fa-file-word {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

/* Smooth scrolling */
.file-structure-tree {
  scroll-behavior: smooth;
}

/* Custom scrollbar */
.file-structure-tree::-webkit-scrollbar {
  width: 8px;
}

.file-structure-tree::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.file-structure-tree::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.file-structure-tree::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Workflow Timeline Styles */
.workflow-timeline {
  position: relative;
  padding-left: 40px;
}

.workflow-step {
  position: relative;
  margin-bottom: 30px;
  display: flex;
  align-items: flex-start;
}

.workflow-step:last-child .step-line {
  display: none;
}

.step-indicator {
  position: absolute;
  left: -40px;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.step-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background-color: #fff;
  border: 3px solid #dee2e6;
  z-index: 2;
  position: relative;
}

.step-line {
  width: 3px;
  height: calc(100% + 30px);
  background-color: #dee2e6;
  margin-top: 40px;
  position: absolute;
  top: 0;
}

.step-content {
  flex: 1 1;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  margin-left: 20px;
  transition: all 0.3s ease;
}

.step-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.step-header h6 {
  margin: 0;
  font-weight: 600;
}

.step-details {
  font-size: 0.9rem;
}

/* Workflow Step States */
.workflow-step.active .step-icon {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.2);
}

.workflow-step.active .step-content {
  border-color: #007bff;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);
}

.workflow-step.active .step-line {
  background-color: #007bff;
}

.workflow-step.completed .step-icon {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

.workflow-step.completed .step-content {
  border-color: #28a745;
  background-color: #f8fff9;
}

.workflow-step.completed .step-line {
  background-color: #28a745;
}

.workflow-step.pending .step-icon {
  background-color: #fff;
  border-color: #dee2e6;
  color: #6c757d;
}

.workflow-step.pending .step-content {
  border-color: #dee2e6;
  background-color: #f8f9fa;
  opacity: 0.7;
}

.workflow-step.returned .step-icon {
  background-color: #ffc107;
  border-color: #ffc107;
  color: white;
}

.workflow-step.returned .step-content {
  border-color: #ffc107;
  background-color: #fffbf0;
}

.workflow-step.returned .step-line {
  background-color: #ffc107;
}

.workflow-step.refused .step-icon {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.workflow-step.refused .step-content {
  border-color: #dc3545;
  background-color: #fff5f5;
}

.workflow-step.refused .step-line {
  background-color: #dc3545;
}

/* Approval History */
.approval-history {
  max-height: 400px;
  overflow-y: auto;
}

`, "",{"version":3,"sources":["webpack://./src/pages/DocumentManagement/DocumentManagement.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,WAAW;EACX,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oDAAoD;EACpD,yBAAiB;UAAjB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,qEAAqE;EACrE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;;EAEE,iDAAiD;AACnD;;AAEA,eAAe;AACf;;EAEE,iDAAiD;AACnD;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/**\r\n * Document Management Module - Styles\r\n */\r\n\r\n.document-management-container {\r\n  min-height: 100vh;\r\n  background-color: #f8f9fa;\r\n  padding-top: 0;\r\n  margin-top: 0;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.document-management-container h2 {\r\n  display: block !important;\r\n  visibility: visible !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.document-management-container .d-flex {\r\n  display: flex !important;\r\n  visibility: visible !important;\r\n}\r\n\r\n/* Ensure upload button is always visible */\r\n.document-management-container .btn-primary {\r\n  position: relative;\r\n  z-index: 10;\r\n  display: inline-flex !important;\r\n  visibility: visible !important;\r\n  opacity: 1 !important;\r\n}\r\n\r\n.document-card {\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.document-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.document-card .card-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.status-indicator {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  margin-right: 8px;\r\n}\r\n\r\n.status-indicator.published {\r\n  background-color: #28a745;\r\n}\r\n\r\n.status-indicator.approved {\r\n  background-color: #28a745;\r\n}\r\n\r\n.status-indicator.under-review {\r\n  background-color: #ffc107;\r\n}\r\n\r\n.status-indicator.draft {\r\n  background-color: #17a2b8;\r\n}\r\n\r\n.status-indicator.expired {\r\n  background-color: #dc3545;\r\n}\r\n\r\n.compliance-status-badge {\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.compliance-status-badge.compliant {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.compliance-status-badge.partially-compliant {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.compliance-status-badge.non-compliant {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.gap-severity-badge {\r\n  padding: 4px 8px;\r\n  border-radius: 8px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.gap-severity-badge.critical {\r\n  background-color: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.gap-severity-badge.high {\r\n  background-color: #fd7e14;\r\n  color: white;\r\n}\r\n\r\n.gap-severity-badge.medium {\r\n  background-color: #ffc107;\r\n  color: #000;\r\n}\r\n\r\n.gap-severity-badge.low {\r\n  background-color: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.version-history-item {\r\n  border-left: 3px solid #dee2e6;\r\n  padding-left: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.version-history-item.current {\r\n  border-left-color: #007bff;\r\n}\r\n\r\n.approval-timeline {\r\n  position: relative;\r\n  padding-left: 24px;\r\n}\r\n\r\n.approval-timeline::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 8px;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 2px;\r\n  background-color: #dee2e6;\r\n}\r\n\r\n.approval-timeline-item {\r\n  position: relative;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.approval-timeline-item::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 4px;\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background-color: #fff;\r\n  border: 2px solid #dee2e6;\r\n}\r\n\r\n.approval-timeline-item.completed::before {\r\n  background-color: #28a745;\r\n  border-color: #28a745;\r\n}\r\n\r\n.approval-timeline-item.pending::before {\r\n  background-color: #ffc107;\r\n  border-color: #ffc107;\r\n}\r\n\r\n.dashboard-stat-card {\r\n  border-left: 4px solid;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.dashboard-stat-card:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.dashboard-stat-card.compliant {\r\n  border-left-color: #28a745;\r\n}\r\n\r\n.dashboard-stat-card.partially-compliant {\r\n  border-left-color: #ffc107;\r\n}\r\n\r\n.dashboard-stat-card.non-compliant {\r\n  border-left-color: #dc3545;\r\n}\r\n\r\n.notification-item {\r\n  border-left: 4px solid;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.notification-item:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.notification-item.info {\r\n  border-left-color: #17a2b8;\r\n}\r\n\r\n.notification-item.warning {\r\n  border-left-color: #ffc107;\r\n}\r\n\r\n.notification-item.critical {\r\n  border-left-color: #dc3545;\r\n}\r\n\r\n.file-upload-area {\r\n  border: 2px dashed #dee2e6;\r\n  border-radius: 8px;\r\n  padding: 40px;\r\n  text-align: center;\r\n  transition: border-color 0.2s, background-color 0.2s;\r\n  cursor: pointer;\r\n}\r\n\r\n.file-upload-area:hover {\r\n  border-color: #007bff;\r\n  background-color: #f0f7ff;\r\n}\r\n\r\n.file-upload-area.dragover {\r\n  border-color: #007bff;\r\n  background-color: #e7f3ff;\r\n}\r\n\r\n.risk-level-badge {\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.risk-level-badge.low {\r\n  background-color: #d1ecf1;\r\n  color: #0c5460;\r\n}\r\n\r\n.risk-level-badge.medium {\r\n  background-color: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.risk-level-badge.high {\r\n  background-color: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n.risk-level-badge.critical {\r\n  background-color: #dc3545;\r\n  color: white;\r\n}\r\n\r\n/* File Structure Styles */\r\n.file-structure-tree {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  background-color: transparent;\r\n  padding: 0;\r\n  width: 100%;\r\n}\r\n\r\n.file-structure-item {\r\n  border-bottom: 1px solid #f0f0f0;\r\n  transition: all 0.2s;\r\n  position: relative;\r\n}\r\n\r\n.file-structure-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.folder-item {\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, border-color 0.2s;\r\n  user-select: none;\r\n  border-left: 3px solid transparent;\r\n  position: relative;\r\n}\r\n\r\n.folder-item:hover {\r\n  background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 100%);\r\n  border-left-color: #ffc107;\r\n}\r\n\r\n.folder-item.custom-folder {\r\n  background-color: #f0f7ff;\r\n  border-left-color: #0dcaf0;\r\n}\r\n\r\n.folder-item.custom-folder:hover {\r\n  background: linear-gradient(90deg, #cfe2ff 0%, #d1e7ff 100%);\r\n  border-left-color: #0dcaf0;\r\n}\r\n\r\n.file-item {\r\n  cursor: pointer;\r\n  transition: background-color 0.2s, border-color 0.2s, box-shadow 0.2s;\r\n  border-left: 3px solid transparent;\r\n  position: relative;\r\n}\r\n\r\n.file-item:hover {\r\n  background: linear-gradient(90deg, #e9ecef 0%, #dee2e6 100%);\r\n  border-left-color: #007bff;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.file-item:active {\r\n  background-color: #e9ecef;\r\n}\r\n\r\n/* Folder icons with better styling */\r\n.folder-item .fa-folder,\r\n.folder-item .fa-folder-open {\r\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n/* File icons */\r\n.file-item .fa-file-pdf,\r\n.file-item .fa-file-word {\r\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n/* Smooth scrolling */\r\n.file-structure-tree {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/* Custom scrollbar */\r\n.file-structure-tree::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.file-structure-tree::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n.file-structure-tree::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.file-structure-tree::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n/* Workflow Timeline Styles */\r\n.workflow-timeline {\r\n  position: relative;\r\n  padding-left: 40px;\r\n}\r\n\r\n.workflow-step {\r\n  position: relative;\r\n  margin-bottom: 30px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.workflow-step:last-child .step-line {\r\n  display: none;\r\n}\r\n\r\n.step-indicator {\r\n  position: absolute;\r\n  left: -40px;\r\n  top: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.step-icon {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  background-color: #fff;\r\n  border: 3px solid #dee2e6;\r\n  z-index: 2;\r\n  position: relative;\r\n}\r\n\r\n.step-line {\r\n  width: 3px;\r\n  height: calc(100% + 30px);\r\n  background-color: #dee2e6;\r\n  margin-top: 40px;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n\r\n.step-content {\r\n  flex: 1;\r\n  background-color: #fff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n  padding: 16px;\r\n  margin-left: 20px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.step-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.step-header h6 {\r\n  margin: 0;\r\n  font-weight: 600;\r\n}\r\n\r\n.step-details {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* Workflow Step States */\r\n.workflow-step.active .step-icon {\r\n  background-color: #007bff;\r\n  border-color: #007bff;\r\n  color: white;\r\n  box-shadow: 0 0 0 4px rgba(0, 123, 255, 0.2);\r\n}\r\n\r\n.workflow-step.active .step-content {\r\n  border-color: #007bff;\r\n  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15);\r\n}\r\n\r\n.workflow-step.active .step-line {\r\n  background-color: #007bff;\r\n}\r\n\r\n.workflow-step.completed .step-icon {\r\n  background-color: #28a745;\r\n  border-color: #28a745;\r\n  color: white;\r\n}\r\n\r\n.workflow-step.completed .step-content {\r\n  border-color: #28a745;\r\n  background-color: #f8fff9;\r\n}\r\n\r\n.workflow-step.completed .step-line {\r\n  background-color: #28a745;\r\n}\r\n\r\n.workflow-step.pending .step-icon {\r\n  background-color: #fff;\r\n  border-color: #dee2e6;\r\n  color: #6c757d;\r\n}\r\n\r\n.workflow-step.pending .step-content {\r\n  border-color: #dee2e6;\r\n  background-color: #f8f9fa;\r\n  opacity: 0.7;\r\n}\r\n\r\n.workflow-step.returned .step-icon {\r\n  background-color: #ffc107;\r\n  border-color: #ffc107;\r\n  color: white;\r\n}\r\n\r\n.workflow-step.returned .step-content {\r\n  border-color: #ffc107;\r\n  background-color: #fffbf0;\r\n}\r\n\r\n.workflow-step.returned .step-line {\r\n  background-color: #ffc107;\r\n}\r\n\r\n.workflow-step.refused .step-icon {\r\n  background-color: #dc3545;\r\n  border-color: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.workflow-step.refused .step-content {\r\n  border-color: #dc3545;\r\n  background-color: #fff5f5;\r\n}\r\n\r\n.workflow-step.refused .step-line {\r\n  background-color: #dc3545;\r\n}\r\n\r\n/* Approval History */\r\n.approval-history {\r\n  max-height: 400px;\r\n  overflow-y: auto;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
